import { Typography } from '@mui/material';

import { HBSelectTreeDataProps } from './HBSelectTree';

export type HBSelectTreeRenderValueProps = {
  value: string | string[] | unknown;
  treeItemSelect: HBSelectTreeDataProps[];
  label: string;
};

export default function HBSelectTreeRenderValue({
  value,
  treeItemSelect,
}: HBSelectTreeRenderValueProps): JSX.Element | null {
  if (value && typeof value === 'string') {
    return <Typography variant="button">{treeItemSelect?.[0]?.label}</Typography>;
  } else if (value && Array.isArray(value) && value.length > 0) {
    return (
      <Typography
        variant="button"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'noWrap',
          width: '98%',
          display: 'inline-block',
        }}
      >
        {treeItemSelect
          ?.slice(0, 20)
          ?.map((item) => item.label)
          .join(', ')}
      </Typography>
    );
  } else {
    return null;
  }
}
